<template>
  <div class="dynamic-detail">
    <div v-if="loading" class="loading">
      <i class="el-icon-loading"></i>
      <span>加载中...</span>
    </div>
    <div v-else-if="!detailData" class="empty-detail">
      <p>内容不存在</p>
    </div>
    <div v-else class="detail-container">
      <!-- 返回按钮 -->
      <div class="back-button" @click="handleBack">
        <i class="el-icon-arrow-left"></i>
        <span>返回列表</span>
      </div>

      <!-- 标题 -->
      <h1 class="detail-title">{{ detailData.title || '无标题' }}</h1>

      <!-- 发布时间 -->
      <div class="detail-meta">
        <span class="publish-time">发布时间：{{ formatDate(detailData.publishTime || detailData.createTime || detailData.updateTime) }}</span>
      </div>

      <!-- 主图 -->
      <!-- <div v-if="detailData.image" class="detail-image">
        <img :src="detailData.image" alt="" @error="handleImageError">
      </div> -->

      <!-- 内容 -->
      <div class="detail-content" v-html="detailData.content"></div>
    </div>
  </div>
</template>

<script>
import { queryDynamicHtmlDetail } from '@/api/menu'

export default {
  name: 'DynamicDetail',
  props: {
    detailId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      detailData: null
    }
  },
  watch: {
    detailId () {
      this.loadDetail()
    }
  },
  mounted () {
    this.loadDetail()
  },
  methods: {
    async loadDetail () {
      if (!this.detailId) {
        return
      }
      this.loading = true
      try {
        const res = await queryDynamicHtmlDetail({ id: this.detailId })
        if (res && res.result) {
          // 解析 htmlContent
          const htmlContent = res.result.htmlContent
          if (htmlContent) {
            try {
              // 尝试解析 JSON
              const parsedContent = JSON.parse(htmlContent)
              this.detailData = {
                title: parsedContent.title || res.result.title || '',
                summary: parsedContent.summary || '',
                content: parsedContent.content || '',
                image: parsedContent.image || res.result.icon || '',
                publishTime: parsedContent.publishTime || res.result.createTime || res.result.updateTime
              }
            } catch (e) {
              // 如果不是 JSON，直接使用原始数据
              this.detailData = {
                title: res.result.title || '',
                content: htmlContent,
                image: res.result.icon || '',
                publishTime: res.result.createTime || res.result.updateTime
              }
            }
          } else {
            // 如果没有 htmlContent，使用其他字段
            this.detailData = {
              title: res.result.title || '',
              content: '',
              image: res.result.icon || '',
              publishTime: res.result.createTime || res.result.updateTime
            }
          }
        }
      } catch (error) {
        console.error('加载详情失败:', error)
        this.detailData = null
      } finally {
        this.loading = false
      }
    },
    formatDate (dateStr) {
      if (!dateStr) return ''
      let date
      if (typeof dateStr === 'number') {
        date = new Date(dateStr)
      } else if (typeof dateStr === 'string') {
        date = new Date(dateStr)
      } else {
        return ''
      }
      if (isNaN(date.getTime())) {
        return ''
      }
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}`
    },
    handleBack () {
      // 返回上一页或列表页
      this.$router.go(-1)
    },
    handleImageError (event) {
      event.target.style.display = 'none'
    }
  }
}
</script>

<style scoped>
.dynamic-detail {
  width: 100%;
  min-height: 60vh;
  background: #fff;
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: #666;
  gap: 12px;
}

.empty-detail {
  text-align: center;
  padding: 60px 0;
  color: #999;
}

.detail-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.back-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  margin-bottom: 24px;
  color: #52c41a;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s;
}

.back-button:hover {
  background: #f0f9ff;
  color: #389e0d;
}

.detail-title {
  font-size: 32px;
  font-weight: 600;
  color: #333;
  margin: 0 0 16px 0;
  line-height: 1.4;
}

.detail-meta {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e8e8e8;
}

.publish-time {
  font-size: 14px;
  color: #999;
}

.detail-image {
  width: 100%;
  margin-bottom: 32px;
  border-radius: 8px;
  overflow: hidden;
}

.detail-image img {
  width: 100%;
  height: auto;
  display: block;
}

.detail-content {
  line-height: 1.8;
  color: #333;
  font-size: 16px;
}

.detail-content ::v-deep img {
  max-width: 100%;
  height: auto;
  margin: 16px 0;
  border-radius: 4px;
}

.detail-content ::v-deep p {
  margin-bottom: 16px;
}

.detail-content ::v-deep h1,
.detail-content ::v-deep h2,
.detail-content ::v-deep h3 {
  margin-top: 32px;
  margin-bottom: 16px;
  color: #333;
  font-weight: 600;
}

.detail-content ::v-deep h1 {
  font-size: 28px;
}

.detail-content ::v-deep h2 {
  font-size: 24px;
}

.detail-content ::v-deep h3 {
  font-size: 20px;
}

.detail-content ::v-deep ul,
.detail-content ::v-deep ol {
  margin: 16px 0;
  padding-left: 24px;
}

.detail-content ::v-deep li {
  margin-bottom: 8px;
}

/* 移动端 */
@media (max-width: 768px) {
  .detail-container {
    padding: 24px 16px;
  }

  .detail-title {
    font-size: 24px;
  }

  .detail-content {
    font-size: 14px;
  }

  .detail-content ::v-deep h1 {
    font-size: 22px;
  }

  .detail-content ::v-deep h2 {
    font-size: 20px;
  }

  .detail-content ::v-deep h3 {
    font-size: 18px;
  }
}
</style>
